import { render, staticRenderFns } from "./repairCardRequest.vue?vue&type=template&id=7246aa56&"
import script from "./repairCardRequest.vue?vue&type=script&lang=js&"
export * from "./repairCardRequest.vue?vue&type=script&lang=js&"
import style0 from "./repairCardRequest.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports